"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRoomTypeMapping = void 0;
exports.filterRoomsByRoomClass = filterRoomsByRoomClass;
exports.getAccessibleRoomData = getAccessibleRoomData;
exports.getAccessibleRoomSelectedPMSRoomTypesAndSpecialRequests = getAccessibleRoomSelectedPMSRoomTypesAndSpecialRequests;
exports.getAllRoomTypesFromRates = getAllRoomTypesFromRates;
exports.getAvailabilityParamsFromUrl = getAvailabilityParamsFromUrl;
exports.getAvailabilityRoomClassIndexes = getAvailabilityRoomClassIndexes;
exports.getAvailableRoomTypes = getAvailableRoomTypes;
exports.getBathRoomSelectedPMSRoomTypesAndSpecialRequests = getBathRoomSelectedPMSRoomTypesAndSpecialRequests;
exports.getHotelAvailabilityQueryKey = getHotelAvailabilityQueryKey;
exports.getPIBrandText = getPIBrandText;
exports.getPMSRoomTypeByRoomType = getPMSRoomTypeByRoomType;
exports.getPMSRoomTypeByRoomTypeAndBathroom = getPMSRoomTypeByRoomTypeAndBathroom;
exports.getRateClassification = getRateClassification;
exports.getRoomClassByCodeAndType = getRoomClassByCodeAndType;
exports.getRoomClassByRoomClassCode = getRoomClassByRoomClassCode;
exports.getRoomClassTextForGAllery = getRoomClassTextForGAllery;
exports.getRoomRatesThatMatchRoomClassifications = getRoomRatesThatMatchRoomClassifications;
exports.getRoomTypesFromQuery = getRoomTypesFromQuery;
exports.getSelectedPMSRoomTypesAndSpecialRequests = getSelectedPMSRoomTypesAndSpecialRequests;
exports.getSelectedRoomClassCode = getSelectedRoomClassCode;
exports.getTwinRoomSelectionPrices = getTwinRoomSelectionPrices;
exports.isAccessibleRoomType = isAccessibleRoomType;
exports.isFaqValidForRender = isFaqValidForRender;
exports.isHotelOpeningSoon = isHotelOpeningSoon;
exports.isItBarrierFree = isItBarrierFree;
exports.isPremierPlusAccessibleRoomByCode = isPremierPlusAccessibleRoomByCode;
exports.isPremierPlusAccessibleRoomByText = isPremierPlusAccessibleRoomByText;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _api = require("@whitbread-eos/api");
var _dateFns = require("date-fns");
var _validators = require("../validators");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function getAvailabilityParamsFromUrl(url) {
  var urlParams = new URLSearchParams(url);
  var year = Number(urlParams.get('ARRyyyy'));
  var month = Number(urlParams.get('ARRmm'));
  var day = Number(urlParams.get('ARRdd'));
  var numberOfNights = Number(urlParams.get('NIGHTS'));
  var numberOfRooms = Number(urlParams.get('ROOMS'));
  var cellCodes = urlParams.get('CELLCODES');
  var empOfferCodes = (cellCodes === null || cellCodes === void 0 ? void 0 : cellCodes.split(',')) || [];
  var corpId = urlParams.get('CORPID');
  var promoId = urlParams.get('PROMOID');
  var arrivalDate = (0, _validators.isDateValid)(day, month, year) ? new Date(year, month - 1, day) : new Date();
  var arrival = (0, _dateFns.format)(arrivalDate, 'yyyy-MM-dd');
  var departure = (0, _dateFns.format)((0, _dateFns.add)(arrivalDate, {
    days: numberOfNights
  }), 'yyyy-MM-dd');
  var rooms = [];
  for (var idx = 0; idx < numberOfRooms; idx++) {
    rooms.push({
      adultsNumber: Number(urlParams.get("ADULT".concat(idx + 1))),
      childrenNumber: Number(urlParams.get("CHILD".concat(idx + 1))),
      roomType: urlParams.get("INTTYP".concat(idx + 1)),
      cotRequired: urlParams.get("COT".concat(idx + 1)) === '1'
    });
  }
  return {
    arrival,
    departure,
    rooms,
    empOfferCodes,
    corpId,
    promoId,
    numberOfNights
  };
}
function getHotelAvailabilityQueryKey(language, country, brand, hotelId, arrival, departure, rooms) {
  var empOfferCodes = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];
  var landingPagePromoCode = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : '';
  var hotelAvailabilityQueryKey = ['hotelAvailability', language, country, brand === null || brand === void 0 ? void 0 : brand.toLowerCase(), hotelId, arrival, departure, JSON.stringify(rooms), empOfferCodes];
  if (landingPagePromoCode) {
    hotelAvailabilityQueryKey.push(landingPagePromoCode);
  }
  return hotelAvailabilityQueryKey;
}
function isHotelOpeningSoon(hotelOpeningDate, arrival) {
  if (!hotelOpeningDate || !arrival) {
    return false;
  }
  try {
    return (0, _dateFns.differenceInDays)(new Date(hotelOpeningDate), new Date(arrival)) > 0;
  } catch (e) {
    return false;
  }
}
function getAvailableRoomTypes() {
  var roomTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return Array.from(new Set(roomTypes === null || roomTypes === void 0 ? void 0 : roomTypes.map(type => type === null || type === void 0 ? void 0 : type.roomType)));
}
function getAllRoomTypesFromRates(roomRates) {
  var allRoomTypes = [];
  roomRates.forEach(roomRate => {
    var _roomRate$roomTypes;
    return roomRate === null || roomRate === void 0 || (_roomRate$roomTypes = roomRate.roomTypes) === null || _roomRate$roomTypes === void 0 ? void 0 : _roomRate$roomTypes.forEach(room => {
      allRoomTypes.push(room);
    });
  });
  return allRoomTypes;
}
function getRoomClassByRoomClassCode(roomClassCode, language) {
  return language === 'en' ? _api.RoomClass[roomClassCode] : _api.DeRoomClass[roomClassCode];
}
function getRateClassification(ratePlanCode) {
  var rateClassifications = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return rateClassifications.find(rate => (rate === null || rate === void 0 ? void 0 : rate.rateClassification) === ratePlanCode || (rate === null || rate === void 0 ? void 0 : rate.ratePlanCode) === ratePlanCode);
}
function getRoomRatesThatMatchRoomClassifications(rateClassifications) {
  var roomRates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return [...roomRates].sort((roomRate1, roomRate2) => {
    var _rateClassifications$, _rateClassifications$2;
    var rate1Order = (_rateClassifications$ = rateClassifications.find(el => (el === null || el === void 0 ? void 0 : el.rateClassification) === (roomRate1 === null || roomRate1 === void 0 ? void 0 : roomRate1.ratePlanCode))) === null || _rateClassifications$ === void 0 ? void 0 : _rateClassifications$.rateOrder;
    var rate2Order = (_rateClassifications$2 = rateClassifications.find(el => (el === null || el === void 0 ? void 0 : el.rateClassification) === (roomRate2 === null || roomRate2 === void 0 ? void 0 : roomRate2.ratePlanCode))) === null || _rateClassifications$2 === void 0 ? void 0 : _rateClassifications$2.rateOrder;
    return rate1Order && rate2Order ? +rate1Order - +rate2Order : 0;
  });
}
function getAvailabilityRoomClassIndexes() {
  var _roomRates$;
  var roomRates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var availableRoomTypes = getAvailableRoomTypes(getAllRoomTypesFromRates(roomRates));
  var {
    STANDARD_ROOM
  } = _api.RoomClassCodes;
  return (availableRoomTypes === null || availableRoomTypes === void 0 ? void 0 : availableRoomTypes.length) > 1 ? [STANDARD_ROOM] : (_roomRates$ = roomRates[0]) === null || _roomRates$ === void 0 || (_roomRates$ = _roomRates$.roomTypes[0].rooms) === null || _roomRates$ === void 0 ? void 0 : _roomRates$.map(room => room === null || room === void 0 ? void 0 : room.roomClass);
}
function getSelectedPMSRoomTypesAndSpecialRequests(twinroomSelections, basketDetailsState) {
  var _basketDetailsState$s;
  var selectedPMSRoomTypes = [];
  var selectedSpecialRequests = [];
  var roomIndex = 0;
  (_basketDetailsState$s = basketDetailsState.selectedRate) === null || _basketDetailsState$s === void 0 || (_basketDetailsState$s = _basketDetailsState$s.roomTypes) === null || _basketDetailsState$s === void 0 || _basketDetailsState$s.forEach(roomType => {
    var _roomType$rooms3, _roomType$rooms4, _isTwoBeds$specialReq, _isDoubleSofa$special;
    if ((roomType === null || roomType === void 0 ? void 0 : roomType.roomType) !== _api.ROOM_TYPE.TWIN) {
      var _roomType$rooms, _roomType$rooms2;
      roomIndex++;
      selectedSpecialRequests.push(roomType === null || roomType === void 0 || (_roomType$rooms = roomType.rooms) === null || _roomType$rooms === void 0 || (_roomType$rooms = _roomType$rooms[0]) === null || _roomType$rooms === void 0 ? void 0 : _roomType$rooms.specialRequests);
      return selectedPMSRoomTypes.push(roomType === null || roomType === void 0 || (_roomType$rooms2 = roomType.rooms) === null || _roomType$rooms2 === void 0 || (_roomType$rooms2 = _roomType$rooms2[0]) === null || _roomType$rooms2 === void 0 ? void 0 : _roomType$rooms2.pmsRoomType);
    }
    var matchTwinRoomSelection = twinroomSelections[roomIndex];
    var isTwoBeds = roomType === null || roomType === void 0 || (_roomType$rooms3 = roomType.rooms) === null || _roomType$rooms3 === void 0 ? void 0 : _roomType$rooms3.find(roomItem => _api.twinRoomImprovedSpecialRequests.includes(roomItem === null || roomItem === void 0 ? void 0 : roomItem.specialRequests[0]));
    var isDoubleSofa = roomType === null || roomType === void 0 || (_roomType$rooms4 = roomType.rooms) === null || _roomType$rooms4 === void 0 ? void 0 : _roomType$rooms4.find(roomItem => _api.twinRoomStandardSpecialRequests.includes(roomItem === null || roomItem === void 0 ? void 0 : roomItem.specialRequests[0]));
    if (matchTwinRoomSelection === _api.ROOM_TYPE.TWIN_TWO_BEDS && isTwoBeds !== null && isTwoBeds !== void 0 && (_isTwoBeds$specialReq = isTwoBeds.specialRequests) !== null && _isTwoBeds$specialReq !== void 0 && _isTwoBeds$specialReq.length) {
      selectedSpecialRequests.push(isTwoBeds === null || isTwoBeds === void 0 ? void 0 : isTwoBeds.specialRequests);
      selectedPMSRoomTypes.push(isTwoBeds === null || isTwoBeds === void 0 ? void 0 : isTwoBeds.pmsRoomType);
    }
    if (matchTwinRoomSelection === _api.ROOM_TYPE.TWIN_DOUBLE_SOFA && isDoubleSofa !== null && isDoubleSofa !== void 0 && (_isDoubleSofa$special = isDoubleSofa.specialRequests) !== null && _isDoubleSofa$special !== void 0 && _isDoubleSofa$special.length) {
      selectedSpecialRequests.push(isDoubleSofa === null || isDoubleSofa === void 0 ? void 0 : isDoubleSofa.specialRequests);
      selectedPMSRoomTypes.push(isDoubleSofa === null || isDoubleSofa === void 0 ? void 0 : isDoubleSofa.pmsRoomType);
    }
    roomIndex++;
  });
  return {
    selectedPMSRoomTypes,
    selectedSpecialRequests
  };
}
function getTwinRoomSelectionPrices(selectedRate) {
  var _selectedRate$roomTyp;
  return selectedRate === null || selectedRate === void 0 || (_selectedRate$roomTyp = selectedRate.roomTypes) === null || _selectedRate$roomTyp === void 0 || (_selectedRate$roomTyp = _selectedRate$roomTyp.find(selectedType => (selectedType === null || selectedType === void 0 ? void 0 : selectedType.roomType) === _api.ROOM_TYPE.TWIN)) === null || _selectedRate$roomTyp === void 0 || (_selectedRate$roomTyp = _selectedRate$roomTyp.rooms) === null || _selectedRate$roomTyp === void 0 || (_selectedRate$roomTyp = _selectedRate$roomTyp.map(room => {
    var _room$roomPriceBreakd, _room$roomPriceBreakd2;
    var hasTwinOptions = element => element === _api.twinRoomImprovedSpecialRequests[0] || element === _api.twinRoomStandardSpecialRequests[0];
    var typeIndex = room.specialRequests.findIndex(hasTwinOptions);
    return {
      twinRoomType: room === null || room === void 0 ? void 0 : room.specialRequests[typeIndex],
      currencyCode: room === null || room === void 0 || (_room$roomPriceBreakd = room.roomPriceBreakdown) === null || _room$roomPriceBreakd === void 0 ? void 0 : _room$roomPriceBreakd.currencyCode,
      price: room === null || room === void 0 || (_room$roomPriceBreakd2 = room.roomPriceBreakdown) === null || _room$roomPriceBreakd2 === void 0 ? void 0 : _room$roomPriceBreakd2.totalNetAmount
    };
  })) === null || _selectedRate$roomTyp === void 0 ? void 0 : _selectedRate$roomTyp.filter((value, index, self) => {
    return self.findIndex(room => (room === null || room === void 0 ? void 0 : room.twinRoomType) === (value === null || value === void 0 ? void 0 : value.twinRoomType)) === index;
  });
}
function getRoomTypesFromQuery(routerQuery, mapping, roomLabel) {
  var roomTypes = [];
  var numberOfRooms = parseInt(routerQuery['ROOMS']) || 1;
  for (var i = 1; i <= numberOfRooms; i++) {
    var inttypKey = "INTTYP".concat(i);
    var queryValue = routerQuery[inttypKey];
    roomTypes.push(mapping[queryValue] + ' ' + roomLabel);
  }
  return roomTypes;
}
function isFaqValidForRender(faq, isFaqEnabled) {
  var _faq$faqItems;
  return faq && !!Object.keys(faq).length && !!(faq !== null && faq !== void 0 && (_faq$faqItems = faq.faqItems) !== null && _faq$faqItems !== void 0 && _faq$faqItems.length) && isFaqEnabled;
}
function getAccessibleRoomData(roomTypes) {
  var chooseRoomTypePage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return roomTypes === null || roomTypes === void 0 ? void 0 : roomTypes.map(roomType => {
    var _roomType$rooms5;
    var accessibleRooms = roomType === null || roomType === void 0 || (_roomType$rooms5 = roomType.rooms) === null || _roomType$rooms5 === void 0 ? void 0 : _roomType$rooms5.filter(room => {
      if (chooseRoomTypePage) {
        return _api.ACCESSIBLE_BARRIER_ROOM_TYPES.includes(room === null || room === void 0 ? void 0 : room.pmsRoomType);
      }
      return isAccessibleRoomType(room === null || room === void 0 ? void 0 : room.pmsRoomType);
    });
    return _objectSpread(_objectSpread({}, roomType), {}, {
      rooms: accessibleRooms !== null && accessibleRooms !== void 0 && accessibleRooms.length ? accessibleRooms : roomType === null || roomType === void 0 ? void 0 : roomType.rooms,
      isRoomAccessible: !!(accessibleRooms !== null && accessibleRooms !== void 0 && accessibleRooms.length)
    });
  });
}
function isAccessibleRoomType(roomType) {
  return _api.ACCESSIBLE_ROOM_TYPES === null || _api.ACCESSIBLE_ROOM_TYPES === void 0 ? void 0 : _api.ACCESSIBLE_ROOM_TYPES.includes(roomType);
}
function getPIBrandText(t, brand) {
  return brand === _api.HotelBrand.PI || brand === _api.HotelBrand.PID ? " ".concat(t('search.new.premierInn'), " ") : ' ';
}
function isPremierPlusAccessibleRoomByCode(roomClassCode, roomType, isPremPlusAccFeatureFlag) {
  return roomClassCode === _api.RoomClassCodes.PREMIER_PLUS_ROOM && roomType === _api.ACCESSIBLE_ROOM_TYPE && isPremPlusAccFeatureFlag;
}
var staticHotelData = (roomClassConfiguration, roomClassCode) => {
  var hotelData = roomClassConfiguration.filter(item => (item === null || item === void 0 ? void 0 : item.code) == roomClassCode ? item === null || item === void 0 ? void 0 : item.title : '');
  if (hotelData && hotelData !== null && hotelData !== void 0 && hotelData.length) {
    return hotelData.map(item => item.title).join(', ');
  }
  return hotelData;
};
function getRoomClassByCodeAndType(roomClass, roomClassCode, roomType, roomTypes, t, isPremPlusAccFeatureFlag, roomClassConfiguration) {
  var staticHotel = staticHotelData(roomClassConfiguration !== null && roomClassConfiguration !== void 0 ? roomClassConfiguration : [], roomClassCode);
  return staticHotel && staticHotel.length > 0 ? staticHotel : _api.RoomClassLabelByCode[roomClassCode] ? t(_api.RoomClassLabelByCode[roomClassCode]) : roomClass;
}
function isPremierPlusAccessibleRoomByText(roomClass, language) {
  var _ref, _roomClass$toLowerCas;
  var matchStr = (_ref = language === 'en' ? _api.RoomClass.PP : _api.DeRoomClass.PP) === null || _ref === void 0 ? void 0 : _ref.toLowerCase();
  return roomClass === null || roomClass === void 0 || (_roomClass$toLowerCas = roomClass.toLowerCase()) === null || _roomClass$toLowerCas === void 0 ? void 0 : _roomClass$toLowerCas.includes(matchStr);
}
function getSelectedRoomClassCode(roomClassName, language) {
  var roomClassObject = language === 'en' ? _api.RoomClass : _api.DeRoomClass;
  return Object.keys(roomClassObject).find(key => roomClassObject[key] === roomClassName);
}
var createRoomTypeMapping = t => {
  var accessibleDouble = t('accessible.double');
  var accessibleTwin = t('accessible.twin');
  return {
    [accessibleDouble]: {
      [_api.ROOM_TYPE.LOWERED]: _api.ROOM_TYPE.LOWERED_DOUBLE,
      [_api.ROOM_TYPE.WET]: _api.ROOM_TYPE.WET_DOUBLE,
      premierPlus: {
        [_api.ROOM_TYPE.LOWERED]: _api.ROOM_TYPE.PREMIER_PLUS_LOWERED_DOUBLE,
        [_api.ROOM_TYPE.WET]: _api.ROOM_TYPE.PREMIER_PLUS_WET_DOUBLE
      }
    },
    [accessibleTwin]: {
      [_api.ROOM_TYPE.LOWERED]: _api.ROOM_TYPE.LOWERED_TWIN,
      [_api.ROOM_TYPE.WET]: _api.ROOM_TYPE.WET_TWIN
    }
  };
};
exports.createRoomTypeMapping = createRoomTypeMapping;
function getPMSRoomTypeByRoomTypeAndBathroom(t, isPremPlusAccFeatureFlag, accessibleRoomIndex, roomTypeSelections, bathroomSelections, isPremierPlusAccessibleRoomSelected) {
  var roomType = roomTypeSelections[accessibleRoomIndex];
  var bathRoomType = bathroomSelections[accessibleRoomIndex];
  var mapping = createRoomTypeMapping(t);
  if (isPremPlusAccFeatureFlag) {
    var _mapping$roomType, _mapping$roomType2;
    return isPremierPlusAccessibleRoomSelected ? (_mapping$roomType = mapping[roomType]) === null || _mapping$roomType === void 0 || (_mapping$roomType = _mapping$roomType.premierPlus) === null || _mapping$roomType === void 0 ? void 0 : _mapping$roomType[bathRoomType] : (_mapping$roomType2 = mapping[roomType]) === null || _mapping$roomType2 === void 0 ? void 0 : _mapping$roomType2[bathRoomType];
  } else {
    var _roomTypeMapping$room, _roomTypeMapping$room2;
    return isPremierPlusAccessibleRoomSelected ? (_roomTypeMapping$room = _api.roomTypeMapping[roomType]) === null || _roomTypeMapping$room === void 0 || (_roomTypeMapping$room = _roomTypeMapping$room.premierPlus) === null || _roomTypeMapping$room === void 0 ? void 0 : _roomTypeMapping$room[bathRoomType] : (_roomTypeMapping$room2 = _api.roomTypeMapping[roomType]) === null || _roomTypeMapping$room2 === void 0 ? void 0 : _roomTypeMapping$room2[bathRoomType];
  }
}
function getBathRoomSelectedPMSRoomTypesAndSpecialRequests(t, isPremPlusAccFeatureFlag, roomTypeSelections, bathroomSelections, basketDetailsState, language) {
  var _basketDetailsState$s2;
  var selectedPMSRoomTypes = [];
  var selectedSpecialRequests = [];
  var accessibleRoomIndex = 0;
  var isPremierPlus = isPremierPlusAccessibleRoomByText(basketDetailsState.roomClass, language);
  (_basketDetailsState$s2 = basketDetailsState.selectedRate) === null || _basketDetailsState$s2 === void 0 || (_basketDetailsState$s2 = _basketDetailsState$s2.roomTypes) === null || _basketDetailsState$s2 === void 0 || _basketDetailsState$s2.forEach(roomType => {
    var _roomType$rooms8;
    if ((roomType === null || roomType === void 0 ? void 0 : roomType.roomType) !== _api.ACCESSIBLE_ROOM_TYPE) {
      var _roomType$rooms6, _roomType$rooms7;
      accessibleRoomIndex++;
      var accessibleRooms = roomType === null || roomType === void 0 || (_roomType$rooms6 = roomType.rooms) === null || _roomType$rooms6 === void 0 ? void 0 : _roomType$rooms6.filter(room => isAccessibleRoomType(room === null || room === void 0 ? void 0 : room.pmsRoomType));
      var selectedRoom = (accessibleRooms === null || accessibleRooms === void 0 ? void 0 : accessibleRooms[0]) || (roomType === null || roomType === void 0 || (_roomType$rooms7 = roomType.rooms) === null || _roomType$rooms7 === void 0 ? void 0 : _roomType$rooms7[0]);
      selectedSpecialRequests.push(selectedRoom === null || selectedRoom === void 0 ? void 0 : selectedRoom.specialRequests);
      selectedPMSRoomTypes.push(selectedRoom === null || selectedRoom === void 0 ? void 0 : selectedRoom.pmsRoomType);
      return;
    }
    var isPremierPlusAccessibleRoomSelected = isPremierPlus && (roomType === null || roomType === void 0 ? void 0 : roomType.roomType) === _api.ACCESSIBLE_ROOM_TYPE;
    var pmsRoomType = getPMSRoomTypeByRoomTypeAndBathroom(t, isPremPlusAccFeatureFlag, accessibleRoomIndex, roomTypeSelections, bathroomSelections, isPremierPlusAccessibleRoomSelected);
    accessibleRoomIndex++;
    if (!pmsRoomType) {
      return;
    }
    var room = roomType === null || roomType === void 0 || (_roomType$rooms8 = roomType.rooms) === null || _roomType$rooms8 === void 0 ? void 0 : _roomType$rooms8.find(room => {
      return (room === null || room === void 0 ? void 0 : room.pmsRoomType) === pmsRoomType;
    });
    if (_api.loweredBathRoomTypes.includes(pmsRoomType)) {
      var _room$specialRequests;
      selectedSpecialRequests.push(room === null || room === void 0 || (_room$specialRequests = room.specialRequests) === null || _room$specialRequests === void 0 ? void 0 : _room$specialRequests.filter(specialRequest => specialRequest !== 'WETR'));
    }
    if (_api.wetBathRoomTypes !== null && _api.wetBathRoomTypes !== void 0 && _api.wetBathRoomTypes.includes(pmsRoomType)) {
      var _room$specialRequests2;
      selectedSpecialRequests.push(room === null || room === void 0 || (_room$specialRequests2 = room.specialRequests) === null || _room$specialRequests2 === void 0 ? void 0 : _room$specialRequests2.filter(specialRequest => specialRequest !== 'LOWB'));
    }
    selectedPMSRoomTypes.push(pmsRoomType);
  });
  return {
    selectedPMSRoomTypes,
    selectedSpecialRequests
  };
}
function getAccessibleRoomSelectedPMSRoomTypesAndSpecialRequests(roomTypeSelections, accessibleRoomTypeSelections, basketDetailsState, roomAvailability) {
  var _basketDetailsState$s3;
  var selectedPMSRoomTypes = [];
  var selectedSpecialRequests = [];
  var accessibleRoomIndex = 0;
  (_basketDetailsState$s3 = basketDetailsState.selectedRate) === null || _basketDetailsState$s3 === void 0 || (_basketDetailsState$s3 = _basketDetailsState$s3.roomTypes) === null || _basketDetailsState$s3 === void 0 || _basketDetailsState$s3.forEach(roomType => {
    var _roomType$rooms11, _room$specialRequests3;
    if ((roomType === null || roomType === void 0 ? void 0 : roomType.roomType) !== _api.ACCESSIBLE_ROOM_TYPE) {
      var _roomType$rooms9, _roomType$rooms10;
      accessibleRoomIndex++;
      var accessibleRooms = roomType === null || roomType === void 0 || (_roomType$rooms9 = roomType.rooms) === null || _roomType$rooms9 === void 0 ? void 0 : _roomType$rooms9.filter(room => isAccessibleRoomType(room === null || room === void 0 ? void 0 : room.pmsRoomType));
      var selectedRoom = (accessibleRooms === null || accessibleRooms === void 0 ? void 0 : accessibleRooms[0]) || (roomType === null || roomType === void 0 || (_roomType$rooms10 = roomType.rooms) === null || _roomType$rooms10 === void 0 ? void 0 : _roomType$rooms10[0]);
      selectedSpecialRequests.push(selectedRoom === null || selectedRoom === void 0 ? void 0 : selectedRoom.specialRequests);
      selectedPMSRoomTypes.push(selectedRoom === null || selectedRoom === void 0 ? void 0 : selectedRoom.pmsRoomType);
      return;
    }
    var pmsRoomType = getPMSRoomTypeByRoomType(accessibleRoomIndex, roomTypeSelections, accessibleRoomTypeSelections, roomAvailability, roomType === null || roomType === void 0 ? void 0 : roomType.rooms);
    accessibleRoomIndex++;
    if (!pmsRoomType) {
      return;
    }
    var room = roomType === null || roomType === void 0 || (_roomType$rooms11 = roomType.rooms) === null || _roomType$rooms11 === void 0 ? void 0 : _roomType$rooms11.find(room => (room === null || room === void 0 ? void 0 : room.pmsRoomType) === pmsRoomType);
    if (room !== null && room !== void 0 && (_room$specialRequests3 = room.specialRequests) !== null && _room$specialRequests3 !== void 0 && _room$specialRequests3.length) selectedSpecialRequests.push(room === null || room === void 0 ? void 0 : room.specialRequests);
    selectedPMSRoomTypes.push(pmsRoomType);
  });
  return {
    selectedPMSRoomTypes,
    selectedSpecialRequests
  };
}
function getPMSRoomTypeByRoomType(accessibleRoomIndex, roomTypeSelections, accessibleRoomTypeSelections, roomAvailability, rooms) {
  var _roomAvailability$fin, _roomTypeMapping$room3;
  var roomType = roomTypeSelections[accessibleRoomIndex];
  var accessibleRoomType = accessibleRoomTypeSelections[accessibleRoomIndex];
  var room = rooms.find(_ref2 => {
    var {
      specialRequests
    } = _ref2;
    return accessibleRoomType === _api.ROOM_TYPE.STANDARD_ACCESSIBLE && (specialRequests.includes('LOWB') || specialRequests.includes('WETR')) || specialRequests.includes('BFRE');
  });
  return (roomAvailability === null || roomAvailability === void 0 || (_roomAvailability$fin = roomAvailability.find(_ref3 => {
    var {
      code,
      availableCount
    } = _ref3;
    return (room === null || room === void 0 ? void 0 : room.pmsRoomType) === code && availableCount > 0;
  })) === null || _roomAvailability$fin === void 0 ? void 0 : _roomAvailability$fin.code) || ((_roomTypeMapping$room3 = _api.roomTypeMapping[roomType]) === null || _roomTypeMapping$room3 === void 0 ? void 0 : _roomTypeMapping$room3[accessibleRoomType]);
}
function getRoomClassTextForGAllery(basketDetailsState, language, isPremPlusAccFeatureFlag) {
  var _basketDetailsState$s4;
  var roomClasscode = getSelectedRoomClassCode(basketDetailsState === null || basketDetailsState === void 0 ? void 0 : basketDetailsState.roomClass, language) || '';
  var roomType = (basketDetailsState === null || basketDetailsState === void 0 || (_basketDetailsState$s4 = basketDetailsState.selectedRate) === null || _basketDetailsState$s4 === void 0 || (_basketDetailsState$s4 = _basketDetailsState$s4.roomTypes[0]) === null || _basketDetailsState$s4 === void 0 ? void 0 : _basketDetailsState$s4.roomType) || '';
  var isPremierPlus = isPremierPlusAccessibleRoomByCode(roomClasscode, roomType, isPremPlusAccFeatureFlag);
  return isPremierPlus || isPremPlusAccFeatureFlag && roomClasscode === _api.RoomClassCodes.PREMIER_PLUS_ROOM ? _api.PREMIER_PLUS_ACCESSIBLE : _api.ACCESSIBLE;
}
function filterRoomsByRoomClass() {
  var roomTypesData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var allowedRoomClass = arguments.length > 1 ? arguments[1] : undefined;
  var isPremPlusAccFeatureFlag = arguments.length > 2 ? arguments[2] : undefined;
  if (!allowedRoomClass || !isPremPlusAccFeatureFlag) {
    return roomTypesData;
  }
  return roomTypesData === null || roomTypesData === void 0 ? void 0 : roomTypesData.map(roomGroup => {
    var _roomGroup$rooms;
    return _objectSpread(_objectSpread({}, roomGroup), {}, {
      rooms: roomGroup === null || roomGroup === void 0 || (_roomGroup$rooms = roomGroup.rooms) === null || _roomGroup$rooms === void 0 ? void 0 : _roomGroup$rooms.filter(room => (room === null || room === void 0 ? void 0 : room.roomClass) === allowedRoomClass)
    });
  }).filter(roomGroup => {
    var _roomGroup$rooms2;
    return (roomGroup === null || roomGroup === void 0 || (_roomGroup$rooms2 = roomGroup.rooms) === null || _roomGroup$rooms2 === void 0 ? void 0 : _roomGroup$rooms2.length) > 0;
  });
}
function isItBarrierFree(selectedRoomCodes, barrierFreeRoomsSpecialRequestCodes, selectedRoomClassCode) {
  return selectedRoomCodes === null || selectedRoomCodes === void 0 ? void 0 : selectedRoomCodes.some(group => {
    var _group$rooms;
    return group === null || group === void 0 || (_group$rooms = group.rooms) === null || _group$rooms === void 0 ? void 0 : _group$rooms.some(room => {
      var _room$specialRequests4;
      return (room === null || room === void 0 ? void 0 : room.roomClass) === selectedRoomClassCode && ((_room$specialRequests4 = room.specialRequests) === null || _room$specialRequests4 === void 0 ? void 0 : _room$specialRequests4.some(code => barrierFreeRoomsSpecialRequestCodes === null || barrierFreeRoomsSpecialRequestCodes === void 0 ? void 0 : barrierFreeRoomsSpecialRequestCodes.includes(code)));
    });
  });
}